import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { ReactComponent as Arrow } from '../images/svgs/green-arrow.svg';

const PatientResourcesCardStyled = styled.div`
    padding-top: 64px;
    a {
        text-decoration: none;
    }
    @media ${theme.device.tablet} {
    }
`;

const Card = styled.div`
    padding: 19px 23px 0;
    margin: 0 auto;
    width: 353.37px;
    height: 154px;
    background: #cce0a3;
    border-radius: 15px;
    transition: 0.2s ease-in;
    cursor: pointer;
    .logo {
        width: 240px;
        margin-bottom: 16px;
    }
    .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    svg {
        transition: 0.2s ease-in;
    }
    &:hover {
        background: #c1d39c;
        svg {
            transform: translateX(5px);
        }
    }
`;

export const PatientResourcesCard: React.FC = () => {
    return (
        <PatientResourcesCardStyled>
            <a
                aria-label="care credit logo"
                target="__blank"
                rel="noopener noreferrer"
                href="http://www.carecredit.com/"
            >
                <Card>
                    <p>Apply Now</p>
                    <div className="flex">
                        <StaticImage
                            className="logo"
                            src="../images/care-credit.png"
                            alt="care credit logo"
                            placeholder="none"
                            quality={100}
                        />
                        <Arrow />
                    </div>
                    <p>In just a few steps</p>
                </Card>
            </a>
        </PatientResourcesCardStyled>
    );
};
